import CoreUtils from './CoreUtils';

export default class UserUtils {
  static formatShortUsername(username) {
    if (CoreUtils.isUndefinedOrNull(username) || typeof username !== 'string')
      return '';

    var charIndex = username.indexOf('@');
    return charIndex > -1
      ? username.substring(0, charIndex)
      : username;
  }
}